// extracted by mini-css-extract-plugin
export default {"root":"athlete-card-tooltip_root__zqyKH","priceLine":"athlete-card-tooltip_priceLine__YOarO","pointer":"athlete-card-tooltip_pointer__4WvBn"};